export const LOAD_REPORT_BY_ID = 'Report/LOAD_REPORT_BY_ID';
export const FETCH_REPORT_BY_ID_REQUEST = 'Report/FETCH_REPORT_BY_ID_REQUEST';
export const FETCH_REPORT_BY_ID_ERROR = 'Report/FETCH_REPORT_BY_ID_ERROR';
export const FETCH_REPORT_BY_ID_RESPONSE = 'Report/FETCH_REPORT_BY_ID_RESPONSE';
export const FETCH_REPORT_DATA_REQUEST = 'Report/FETCH_REPORT_DATA_REQUEST';
export const FETCH_REPORT_DATA_RESPONSE = 'Report/FETCH_REPORT_DATA_RESPONSE';
export const FETCH_REPORT_DATA_ERROR = 'Report/FETCH_REPORT_DATA_ERROR';
export const FETCH_REPORT_MODAL_TABLE_DATA_REQUEST = 'Report/FETCH_REPORT_TABLE_DATA_REQUEST';
export const FETCH_REPORT_MODAL_TABLE_DATA_RESPONSE =
  'Report/FETCH_REPORT_MODAL_TABLE_DATA_RESPONSE';
export const FETCH_REPORT_MODAL_TABLE_DATA_ERROR = 'Report/FETCH_REPORT_MODAL_TABLE_DATA_ERROR';
export const UPDATE_REPORT_MODAL_TABLE_DATA = 'Report/UPDATE_REPORT_MODAL_TABLE_DATA';
export const FETCH_UPDATE_REPORT_MODAL_TABLE_DATA_RESPONSE =
  'Report/FETCH_UPDATE_REPORT_MODAL_TABLE_DATA_RESPONSE';
export const EXPORT_REPORT_DATA_AS_CSV_REQUEST = 'Report/EXPORT_REPORT_DATA_AS_CSV_REQUEST';
export const EXPORT_REPORT_DATA_AS_CSV_RESPONSE = 'Report/EXPORT_REPORT_DATA_AS_CSV_RESPONSE';
export const EXPORT_REPORT_DATA_AS_CSV_ERROR = 'Report/EXPORT_REPORT_DATA_AS_CSV_ERROR';
export const SAVE_AND_EXPORT_REPORT_DATA_AS_CSV_REQUEST =
  'Report/SAVE_AND_EXPORT_REPORT_DATA_AS_CSV_REQUEST';

export const UPDATE_REPORT_FILTERS = 'Report/UPDATE_REPORT_FILTERS';

export const ADD_REPORTING_TYPE_MODAL_ID = 'Report/ADD_REPORTING_TYPE_MODAL_ID';
export const REMOVE_REPORTING_TYPE_MODAL_ID = 'Report/REMOVE_REPORTING_TYPE_MODAL_ID';
export const CLEAR_REPORTING_TYPE_MODAL_IDS = 'Report/CLEAR_REPORTING_TYPE_MODAL_IDS';
export const UPDATE_REPORTING_TYPE_IDS = 'Report/UPDATE_REPORTING_TYPE_IDS';
export const SELECT_HIGHCHARTS_TYPE = 'Report/SELECT_HIGHCHARTS_TYPE ';
export const UPDATE_METRICS_LIST = 'Report/UPDATE_METRICS_LIST';
export const METRICS_LIST_UPDATED = 'Report/METRICS_LIST_UPDATED';
export const REPORT_PARAMS_UPDATED = 'Report/REPORT_PARAMS_UPDATED';
export const UPDATE_METRICS_LIST_ERROR = 'Report/UPDATE_METRICS_LIST_ERROR';
export const RESET_REPORT = 'Report/RESET_REPORT';

export const INITIALIZE_SELECTED_TYPE_IDS = 'Report/INITIALIZE_SELECTED_TYPE_IDS';

export const SAVE_NEW_REPORT = 'Report/SAVE_NEW_REPORT';
export const SAVE_REPORT_REQUEST = 'Report/SAVE_REPORT_REQUEST';
export const SAVE_REPORT_RESPONSE = 'Report/SAVE_REPORT_RESPONSE';
export const SAVE_REPORT_ERROR = 'Report/SAVE_REPORT_ERROR';

export const RESET_REPORT_DATA_VIEWS = 'Reports/RESET_REPORT_DATA_VIEWS';

export const UPDATE_TABLE_CONFIG = 'Reports/UPDATE_TABLE_CONFIG';

export const UPDATE_ACTIVE_DATA_VIEW_ITEM = 'Reports/UPDATE_ACTIVE_DATA_VIEW_ITEM';
